import ServicePageTemplate from "@/components/landing/ServicePageTemplate";
export default function ChapaPage() { return <ServicePageTemplate slug="chapa" />; }
